<template>
    <div>
        <Slick ref="slick" :options="slickOptions" v-if="pages.length">
            <div :id="`pdf_page_${page.pageNumber}`"
                 v-for="(page, index) in pages">
                <PDFPageSingle
                    :page="page"
                    :key="index"
                    :signatures="signatures"
                    :signature.sync="signature"
                    :unsigned-blocks="unsignedBlocks"
                    :open.sync="open"
                />
            </div>
        </Slick>
        <user-signature-modal
            :signature="signature"
            :submit-url="submitUrl"
            :save-signature-url="saveSignatureUrl"
            :user="user"
            :open.sync="open"
            :verification-signature="verificationSignature"
            :contract-signature="contractSignature"
            :get-existing-signature="getExistingSignature"
            :save-reusable-signature="saveReusableSignature"
        ></user-signature-modal>
    </div>
</template>

<script>
import PDFPageSingle from './PDFPageSingle';
import UserSignatureModal from "@frontend/components/UserSignatureModal";
import Slick from 'vue-slick';
import {mapGetters} from "vuex";

export default {
    name: 'PDFDocumentCustomUser',

    components: {
        PDFPageSingle,
        Slick,
        UserSignatureModal
    },

    props: {
        pages: {
            required: true,
        },
        pageCount: {
            type: Number,
            default: 0,
        },
        currentPage: {
            type: Number,
            default: 1,
        },
        signatures: {
            required: false,
        },
        saveSignatureUrl: {
            required: true,
            type: String
        },
        submitUrl: {
            required: true,
            type: String
        },
        contractSignature: {
            required: true,
            type: Object
        },
        unsignedBlocks: {
            required: true,
            type: Array
        },
        user: {
            type: Object
        },
        getExistingSignature: {
            required: false
        },
        saveReusableSignature: {
            required: false
        }
    },
    data() {
        return {
            open: false,
            verificationSignature: false,
            signature: null,
            slickOptions: {
                slidesToShow: 1,
                infinite: false,
                slidesToScroll: 1,
                swipeToSlide: false,
                touchMove: false,
                prevArrow: '',
                nextArrow: '',
                draggable: false,
                fade: true,
                dots: false,
            },
        }
    },

    mounted() {
        this.$bus.$on('openPad', this.openPad);
        this.$bus.$on("add-signature", value => {
            if (this.signature) this.traversedSignature(this.signature);
        });

        this.$bus.$on("change-page", value => {
            // make image loaded false;
            //   every time page number changes;
            this.imageLoaded = false;
        });

        this.$bus.$on("insert-verification-signature", value => {
            this.verificationSignature = true;
            this.open = true;
        });
    },
    beforeDestroy() {
        this.$bus.$off("add-signature");
        this.$bus.$off("change-page");
        this.$bus.$off("openPad");
        this.$bus.$off("insert-verification-signature");
    },

    watch: {
        open(newVal, oldVal) {
            // set the verification signature false every time it is closed;
            if (!newVal) this.verificationSignature = false;
        }
    },
    computed: {
        ...mapGetters({
            customerSignature: "signature/getCustomerSignature"
        })
    },

    methods: {
        next() {
            this.$refs.slick.next();
        },
        prev() {
            this.$refs.slick.prev();
        },

        openPad(signature) {
            this.signature = signature;
            this.open = true;
        },
        isShowSignature(signature) {
            if (signature.is_traversed) return this.customerSignature ? true : false;
            return false;
        },
        traversedSignature(signature) {
            axios
                .put(
                    `/ambition-sign/${this.contractSignature.application_id}/${signature.user_id}/document/${this.contractSignature.id}/signatures/${signature.id}`,
                    {}
                )
                .then(res => {
                    this.signature.is_traversed = true;
                    let faElem = document.getElementById(`fa-${signature.id}`);
                    if (faElem) faElem.remove(); // force remove all fa
                    this.$emit("traversing-document", true);
                })
                .catch(err => {
                    console.error(err);
                });
        },
    },
};
</script>

<style lang="sass">
.slick-slider
    touchAction: auto

.slick-track
    display: flex

.slick-slide
    margin: 0 auto

%mask
    display: block
    position: absolute
    top: 0%
    left: 0%
    width: 100%
    cursor: pointer
    height: 100%
    z:
        index: 1

.mask
    @extend %mask
// height: 64px
// width: 240px

.maskActive
    border:
        radius: 0px
    background:
        color: #f8a52b
    font:
        size: 10px
    padding: 0rem !important
    justify-content: center !important

.maskImage
//   border: dashed
  background:
  color: transparent

.mask-label
    font:
        size: 18px !important
    color: #fff


.image-placeholder
    border:
        width: 0.5px
        style: solid
        color: #bdbdbd


.mask-button
    background: transparent
    border: none
    float: right

.max-h
    height: 64px
    width: 240px


.disselect
    -webkit:
        user:
            drag: none
            select: none
    -khtml:
        user:
            drag: none
            select: none
    -moz:
        user:
            drag: none
            select: none
    -o:
        user:
            drag: none
            select: none
    user:
        drag: none
        select: none


</style>
